import React from 'react'
import Typography from '@material-ui/core/Typography'

const BookVectorizationFlow = ({ compact = false }) => (
  <div
    style={{
      border: '1px solid #d8e5f3',
      borderRadius: 4,
      backgroundColor: '#f5f9fd',
      padding: compact ? '10px 12px' : '12px 16px',
      marginBottom: 16,
    }}
  >
    <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4 }}>
      Fluxo do livro
    </Typography>
    <Typography variant="body2" color="textSecondary">
      1. Pré-cadastro no CMS → 2. Upload e vetorização → 3. Revisão e cadastro dos capítulos
    </Typography>
  </div>
)

export default BookVectorizationFlow



// WEBPACK FOOTER //
// ./src/components/BookVectorizationFlow.js